module.exports = __webpack_public_path__ + "img/company32.8ca28c41.png";